module.exports = {
	url: '/contact',
	template: require('raw!templates/contact/contact-view.html'),
	controller: ContactController,
	controllerAs: 'contactCtrl'
}

function ContactController(contentful, $window, $state, $http, $timeout, $scope) {
	var vm = this;
	$window.scrollTo(0, 0);
	vm.showForm = true;
	vm.showConfirmationLayer = false;
	vm.showErrorLayer = false;

	vm.submitForm = function(formValid) {
		if (formValid) {
			var postUrl = "/api/contact";
			var reason = "test";
			var obj = {
				fromName: vm.contactForm.firstName + ' ' + vm.contactForm.lastName,
				fromEmail: vm.contactForm.email,
				toName: 'Guest Services',
				toEmail: 'guestservices@parkcitypeaks.com',
				subject: 'Peaks Park City | Contact Form',
				emailBody: vm.contactForm.comments
			};

			// FAKE FORM POST FOR DEVELOPMENT
			// console.log('valid, emailing ' + obj.toEmail)
			// vm.showConfirmationLayer = true;
			// $timeout(function(){
			//   vm.contactForm = '';
			//   vm.showConfirmationLayer = false;
			// }, 5000);

			$http.post(postUrl, obj).then(function success(res) {
				// console.log('success: ', res);
				vm.showForm = false;
				vm.showConfirmationLayer = true;
				// $timeout(function() {
				// 	vm.contactForm = '';
				// 	vm.showConfirmationLayer = false;
				// }, 10000);
			}, function error(err) {
				// console.log('error: ', err)
				window.glob = err;
				vm.showErrorLayer = true;
				$timeout(function() {
					vm.contactForm = '';
					vm.showErrorLayer = false;
				}, 5000);
			});
		} else {
			// console.log("form invalid");
		}
	};

	contentful.entries('content_type=longPage&sys.id=6M2b4SINagSMEiwga0mi4').then(function(res) {
		// console.log('meetings page contentful data',res);
		$scope.contact = res.data.items[0];
		var seoData = res.data.items[0];
		if (seoData.fields.seoPageTitle) {
			document.title = seoData.fields.seoPageTitle;
		}
		if (seoData.fields.seoPageDescription) {
			var meta = document.getElementsByTagName("meta");
			for (var i = 0; i < meta.length; i++) {
				if (meta[i].name.toLowerCase() === "description") {
					meta[i].content = seoData.fields.seoPageDescription;
				}
			}
		}
	});

}



// WEBPACK FOOTER //
// ./components/templates/contact/contact-controller.js